<template>
  <div class="login-body-polished">
    <div class="container">
      <!-- Left Panel - Branding & Info -->
      <div class="left-panel">
        <div class="brand-content">
          <div class="logo-container">
            <div class="logo">
              <!-- Using Vue asset alias for logo -->
              <img src="@/assets/logo.png" alt="BidSnap AI Logo" width="56" height="56" class="logo-style">
            </div>
            <h1 class="brand-name">BidSnap AI</h1>
          </div>

          <div class="hero-content text-left">
            <h2 class="hero-title text-left">Welcome back to your BidSnap dashboard</h2>
            <p class="hero-description text-left">Manage your tenders, discover opportunities, analyze eligibility and
              make smarter bid decisions powered by AI.</p>

            <div class="features">
              <!-- Feature 1 -->
              <div class="feature-item">
                <div class="feature-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M21 21L16.65 16.65" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </div>
                <div class="flex-1">
                  <div class="block mb-2px" style="font-weight: 600;">Real-time bid
                    discovery</div>
                  <div class="text-sm opacity-90 leading-tight">Our AI continuously
                    scans various tender portals and delivers only relevant opportunities tailored to your
                    business profile.</div>
                </div>
              </div>

              <!-- Feature 2 -->
              <div class="feature-item">
                <div class="feature-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M9 12L11 14L15 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </div>
                <div class="flex-1">
                  <div class="block mb-2px" style="font-weight: 600;">Intelligent
                    eligibility analysis</div>
                  <div class="text-sm opacity-90 leading-tight">Instantly evaluate
                    technical and financial criteria to avoid mismatches and focus on high-potential
                    bids.</div>
                </div>
              </div>

              <!-- Feature 3 -->
              <div class="feature-item">
                <div class="feature-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 3V21H21" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M7 15L11 11L14 14L20 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M20 8H16M20 8V12" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </div>
                <div class="flex-1">
                  <div class="block mb-2px" style="font-weight: 600;">Predictive success
                    analytics</div>
                  <div class="text-sm opacity-90 leading-tight">Use AI-driven scoring
                    and win-probability insights to plan strategically and improve your bid success
                    ratio.</div>
                </div>
              </div>
              <!-- Feature 4 -->
              <div class="feature-item">
                <div class="feature-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12 2L3 6V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V6L12 2Z"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12 8V12" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M12 16H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </div>
                <div class="flex-1">
                  <div class="block mb-2px" style="font-weight: 600;">Predictive Contractual risk
                    </div>
                  <div class="text-sm opacity-90 leading-tight">AI flags risky
                    clauses—penalties, liabilities, payment terms and more—so you can assess contractual
                    exposure before you commit.</div>
                </div>
              </div>
              <!-- Feature 5 -->
              <div class="feature-item">
                <div class="feature-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M9 14L11 16L15 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </div>
                <div class="flex-1">
                  <div class="block mb-2px" style="font-weight: 600;">Contract Management
                    </div>
                  <div class="text-sm opacity-90 leading-tight">Track obligations,
                    milestones and deadlines in one place, with reminders and documents to keep every
                    awarded contract on course.</div>
                </div>
              </div>


            </div>
          </div>


        </div>

        <div class="decorative-elements">
          <div class="blob blob-1"></div>
          <div class="blob blob-2"></div>
          <div class="blob blob-3"></div>
        </div>
      </div>

      <!-- Right Panel - Login Form -->
      <div class="right-panel">
        <div class="login-container">
          <div class="login-header text-left">
            <h2 class="login-title text-left">Sign in to your Intelvo account</h2>
            <p class="login-subtitle text-left">Enter your credentials to access your AI-powered bidding dashboard.</p>
          </div>

          <form class="login-form" @submit.prevent="loginSubmit">

            <div class="form-group">
              <label for="email" class="form-label block text-left">Email address</label>
              <div class="input-wrapper">
                <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M22 6L12 13L2 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
                <input type="email" id="email" class="form-input" :class="{ 'error-input': errors.email }"
                  placeholder="you@example.com" v-model="email">
              </div>
              <p v-if="errors.email" class="error-msg">{{ errors.email }}</p>
            </div>

            <div class="form-group">
              <label for="password" class="form-label block text-left">Password</label>
              <div class="input-wrapper">
                <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <input :type="showPassword ? 'text' : 'password'" id="password" class="form-input"
                  :class="{ 'error-input': errors.password }" placeholder="••••••••" v-model="password">
                <button type="button" class="toggle-password" id="togglePassword" @click="showPassword = !showPassword">
                  <svg class="eye-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" />
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
              <p v-if="errors.password" class="error-msg">{{ errors.password }}</p>
              <div class="text-right mt-2">
                <a @click.prevent="$router.push({ name: 'ForgotPassword' })" class="forgot-link" href="#">Forgot
                  password?</a>
              </div>
            </div>


            <button type="submit" class="btn-primary">
              <span class="btn-text">Sign in</span>
              <svg class="btn-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M12 5L19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>


          </form>

          <div class="text-center mt-6 text-gray-600">
            Don't have an account? <a @click.prevent="routeRegistration" href="#" class="signup-link-style">Sign Up</a>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { generateCodeVerifier, generateCodeChallenge, generateState, beginPkceAuthorize } from '@/utils/pkce';

// OAuth client registered in the backend `oauth_clients` table (seeded in
// migration_script.sql). The redirect URI must match the seeded allowlist.
const OAUTH_CLIENT_ID = 'bid-ui-spa';

export default {
  name: 'LoginPage',

  props: {
    headerVisiblity: Function
  },

  data() {
    return {
      email: "",
      password: "",
      error_login: "",
      showPassword: false,
      errors: {}
    }
  },

  created() {
    // Already logged-in users have no reason to see the login page.
    if (localStorage.getItem('user-info')) {
      this.$router.replace({ name: 'Tenders' });
      return;
    }
    this.headerVisiblity(true);

    // SSO probe: if the user is already signed in on the other app (shared
    // auth-server session), silently log them in here too — no form. We probe
    // once per tab (guard flag) to avoid a redirect loop when there's no session.
    if (!sessionStorage.getItem('sso_probed')) {
      sessionStorage.setItem('sso_probed', '1');
      beginPkceAuthorize(this.$API_URL, OAUTH_CLIENT_ID, { prompt: 'none' });
    }
  },

  methods: {
    validateEmail: function (email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email.trim());
    },


    // Primary login — drives the OAuth2 Authorization Code + PKCE flow using the
    // email/password entered here. We generate the PKCE verifier/challenge, stash
    // the verifier + state for the callback, then POST credentials to the backend
    // /oauth/authorize. That endpoint validates against MySQL and 302-redirects to
    // /auth/callback?code=..., which exchanges the code + verifier for tokens.
    // No credentials are ever posted to the legacy /token endpoint.
    async loginSubmit() {
      this.error_login = "";
      this.errors = {};

      // Required-field validation
      if (!this.email.trim()) {
        this.errors.email = "Email is required";
      }
      if (!this.password.trim()) {
        this.errors.password = "Password is required";
      }
      if (Object.keys(this.errors).length > 0) {
        return;
      }
      if (!this.validateEmail(this.email)) {
        this.errors.email = "Please enter a valid email";
        return;
      }

      try {
        await this.submitPkceLogin(this.email, this.password);
      } catch (e) {
        console.error("Failed to start PKCE login", e);
        this.errors = { password: "Could not start secure sign-in. Please try again." };
      }
    },

    // Builds the PKCE params and performs a native (full-page) form POST to
    // /oauth/authorize so the browser follows the server's 302 to /auth/callback.
    // A native form is required because the response is a redirect, not JSON.
    async submitPkceLogin(email, password) {
      const codeVerifier = generateCodeVerifier();
      const codeChallenge = await generateCodeChallenge(codeVerifier);
      const state = generateState();

      sessionStorage.setItem('pkce_code_verifier', codeVerifier);
      sessionStorage.setItem('pkce_state', state);

      const redirectUri = window.location.origin + '/auth/callback';

      // OAuth params travel in the query string (backend reads them from there on
      // POST); credentials travel in the form body.
      const query = new URLSearchParams({
        response_type: 'code',
        client_id: OAUTH_CLIENT_ID,
        redirect_uri: redirectUri,
        code_challenge: codeChallenge,
        code_challenge_method: 'S256',
        scope: 'openid profile',
        state,
      });

      const form = document.createElement('form');
      form.method = 'POST';
      form.action = this.$API_URL + '/oauth/authorize?' + query.toString();

      const addField = (name, value) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
      };
      addField('email', email);
      addField('password', password);

      document.body.appendChild(form);
      form.submit();
    },

    routeRegistration: function () {
      this.$router.push({ name: 'UserRegistration' });
    }
  }

}
</script>

<style scoped>
/* With the header now visible, the page can't claim the full 100vh —
   fill the space left under the header instead (#app is a flex column). */
.login-body-polished {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.login-body-polished .container {
  height: 100%;
  flex: 1;
  min-height: 0;
}
</style>
